.lab {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-4);
  padding: var(--tuna-spacing-4);
}

.workspace {
  display: flex;
  gap: var(--tuna-spacing-4);
  flex-wrap: wrap;
}

.left {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
  flex: 1 1 auto;
  min-width: 0;
}

.controls {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-3);
  flex-wrap: wrap;
}

@media (max-width: 959px) {
  .workspace {
    flex-direction: column;
  }
}

@media (max-width: 640px) {
  .controls {
    gap: var(--tuna-spacing-2);
  }
}
